import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const RejectedIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon sx={{ width: '24px', height: '24px' }} {...props}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="24" height="24" rx="12" fill="#6B3433" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.375 6.875H7.75C7.23125 6.875 6.7875 7.1875 6.6 7.6375L4.7125 12.0438C4.65625 12.1875 4.625 12.3375 4.625 12.5V13.75C4.625 14.4375 5.1875 15 5.875 15H9.81875L9.225 17.8562L9.20625 18.0562C9.20625 18.3125 9.3125 18.55 9.48125 18.7188L10.1438 19.375L14.2625 15.2563C14.4875 15.0312 14.625 14.7188 14.625 14.375V8.125C14.625 7.4375 14.0625 6.875 13.375 6.875ZM13.375 14.375L10.6625 17.0875L11.5 13.75H5.875V12.5L7.75 8.125H13.375V14.375ZM15.875 6.875H18.375V14.375H15.875V6.875Z"
          fill="#EA3632"
        />
      </svg>
    </SvgIcon>
  );
};

export default RejectedIcon;
